import { httpInstance } from '@/services/httpInstance';

const getTaxesService = async () => {
  let res;
  const endpoint = '/fares/v1/taxes/all';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getTaxesService;
